import createIcon from '../../createIcon';

/**
 * @component @name InsertPageBreak
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNCAyMEM0IDIxLjEgNC44OSAyMiA1Ljk5IDIySDE4QzE5LjEgMjIgMjAgMjEuMSAyMCAyMFYxN0g0VjIwWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTIwIDhMMTQgMkg2QzQuOSAyIDQuMDEgMi45IDQuMDEgNFYxMUgyMFY4Wk0xMyA5VjMuNUwxOC41IDlIMTNaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTUgMTNIOVYxNUgxNVYxM1oiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMyAxM0gxN1YxNUgyM1YxM1oiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik03IDEzSDFWMTVIN1YxM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const InsertPageBreak = createIcon('InsertPageBreak', [
  ['path', { d: 'M4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V17H4V20Z', key: 'hgwa0t' }],
  ['path', { d: 'M20 8L14 2H6C4.9 2 4.01 2.9 4.01 4V11H20V8ZM13 9V3.5L18.5 9H13Z', key: '1dpwz4' }],
  ['path', { d: 'M15 13H9V15H15V13Z', key: '1sgybl' }],
  ['path', { d: 'M23 13H17V15H23V13Z', key: '1l7g24' }],
  ['path', { d: 'M7 13H1V15H7V13Z', key: '9m9l52' }],
]);

export default InsertPageBreak;
